import { useEffect, useState } from "react";
import { description, messages } from "../../../src/resources/strings";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { DELETE_ACCOUNT_ROUTE } from "../../../src/navigation/NavigationConstants";
import { ScreenNameList } from "@lib/utilities/Constants";
import { deleteAccountHandler } from "@lib";

const useDeleteAccount = () => {
  const [errorHandle, setErrorHandle] = useState(messages.error.noError);
  const [isContinuePressed, setContinuePressed] = useState(false);

  useEffect(() => {
    Crashlytics.logScreen(DELETE_ACCOUNT_ROUTE);
  }, []);

  const { deleteUser } = deleteAccountHandler(setErrorHandle);

  // Submit button action for deleting the account
  const submitButtonAction = async () => {
    if (!isContinuePressed) {
      setContinuePressed(true);
    } else {
      deleteUser();
    }
  };

  const errorData = {
    message: errorHandle,
    screenName: ScreenNameList.deleteAccount,
  };

  const onEndTimer = () => {
    setErrorHandle(messages.error.noError);
  };

  const deleteAccountDescData = [
    description.delete.description1,
    description.delete.description2,
    description.delete.description3,
    description.delete.description4,
  ];

  return {
    deleteAccountDescData,
    isContinuePressed,
    submitButtonAction,
    errorData,
    onEndTimer,
  };
};

export default useDeleteAccount;
